import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelComponent } from './label.component';
import { HintModule } from '../../generic-compounds/hint/hint.module';

@NgModule({
	imports: [
		CommonModule,
		HintModule

	],
	declarations: [LabelComponent],
	exports: [
		LabelComponent
	]
})
export class LabelModule { }
